module.exports = __webpack_public_path__ + "img/turkcell-foursquare-launch-03.874dccb0.jpg";